<template>
  <div class="navbar">
    <div class="left-menu">
      <hamburger class="hamburger-container" />
      <breadcrumb class="breadcrumb-container" />
    </div>
    <div class="right-menu">
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <i class="el-icon-s-custom avatar-icon"></i>
          <span class="user-name">{{ userName }}</span>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/profile">
            <el-dropdown-item>个人信息</el-dropdown-item>
          </router-link>
          <router-link to="/change-password">
            <el-dropdown-item>修改密码</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { clearAuth, getUserInfo } from '@/utils/auth'

export default {
  name: 'Navbar',
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    return {
      userName: '未登录'
    }
  },
  created() {
    this.getUserName()
  },
  mounted() {
    // 组件挂载后再次尝试获取用户信息
    setTimeout(() => {
      this.getUserName()
    }, 500)
  },
  methods: {
    getUserName() {
      const userInfo = getUserInfo()
if (userInfo && userInfo.username) {
        // 只显示用户名，不显示单位名称
        this.userName = userInfo.username
      }
    },
    logout() {
      this.$confirm('确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        clearAuth()
        this.$router.push('/login')
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 56px;
  overflow: hidden;
  position: relative;
  z-index: 2;
  width: 100%;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px 0 8px;

  .left-menu {
    display: flex;
    align-items: center;
    height: 56px;
    gap: 4px;
  }

  .hamburger-container {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  .breadcrumb-container {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    line-height: 56px;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 56px;
    display: flex;
    align-items: center;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #fff;
      vertical-align: middle;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.2s;

        &:hover {
          background: rgba(255, 255, 255, 0.1);
        }
      }
    }

    .avatar-container {
      margin-right: 24px;

      .avatar-wrapper {
        display: flex;
        align-items: center;
        
        .avatar-icon {
          font-size: 20px;
          margin-right: 6px;
          color: #fff;
        }
        
        .user-name {
          margin-right: 4px;
          font-size: 14px;
          color: #fff;
        }

        .el-icon-caret-bottom {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.85);
        }
      }
    }
  }
}
</style> 